export enum LineCategory {
  Motor = 'Motor',
  Medical = 'Medical',
  Travel = 'Travel',
  Expat = 'Expat',
  Generic = 'Generic',
  RedBridgeTravel = 'RedBridgeTravel',
}

export enum GenericLines {
  BBB = 'BBB',
  MARINE = 'MARINE',
  MARINE_HULL = 'MARINE_HULL',
  MEDICAL_GROUP = 'MEDICAL_GROUP',
  GENERIC = 'GENERIC',
  PLATE_GLASS = 'PLATE_GLASS'
}
